// src/staticNews.js
const staticNews = [
  { id: "17", date: "15.04.2025", titleKey: "news17.title", path: "/news17" },
  { id: "16", date: "03.04.2025", titleKey: "news16.title", path: "/news16" },
  { id: "15", date: "21.03.2025", titleKey: "news15.title", path: "/news15" },
  { id: "14", date: "08.03.2025", titleKey: "news14.title", path: "/news14" },
  { id: "13", date: "18.03.2025", titleKey: "news13.title", path: "/news13" },
  { id: "12", date: "21.02.2025", titleKey: "news12.title", path: "/news12" },
  { id: "11", date: "19.02.2025", titleKey: "news11.title", path: "/news11" },
  { id: "10", date: "11.02.2025", titleKey: "news10.title", path: "/news10" },
  { id: "9", date: "11.02.2025", titleKey: "news9.title", path: "/news9" },
  { id: "8", date: "07.02.2025", titleKey: "news8.title", path: "/news8" },
  { id: "7", date: "05.02.2025", titleKey: "news7.title", path: "/news7" },
  { id: "6", date: "05.02.2025", titleKey: "news6.title", path: "/news6" },
  { id: "5", date: "15.01.2025", titleKey: "news5.title", path: "/news5" },
  { id: "4", date: "30.12.2024", titleKey: "news4.title", path: "/news4" },
  { id: "3", date: "09.01.2025", titleKey: "news3.title", path: "/news3" },
  { id: "2", date: "27.12.2024", titleKey: "news2.title", path: "/news2" },
  { id: "1", date: "12.12.2024", titleKey: "news1.title", path: "/news1" },
];

export default staticNews;